/** @format */

import React from "react";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "right",
      labels: {
        color: "#333",
        font: {
          size: 14,
          family: "'Segoe UI', sans-serif",
        },
        padding: 16,
      },
    },
    tooltip: {
      backgroundColor: "#ffffff",
      titleColor: "#000",
      bodyColor: "#000",
      borderColor: "#E5E7EB",
      borderWidth: 1,
      titleFont: { weight: "bold", size: 14 },
      bodyFont: { size: 13 },
      padding: 10,
      callbacks: {
        label: function (context) {
          return `${context.label}: ${context.raw} m³/s`;
        },
      },
    },
    datalabels: {
      formatter: (value) => `${value} m³/s`,
      color: "#fff",
      font: {
        weight: "bold",
        size: 13,
        family: "'Segoe UI', sans-serif",
      },
    },
  },
};

const PieChart2 = ({ d1, d2, d3, d4 }) => {
  const data = {
    labels: [`O’zbekiston - ${d3} m³/s`, `Turkmaniston - ${d4} m³/s`],
    datasets: [
      {
        label: "Suv taqsimoti",
        data: [d1, d2],
        backgroundColor: ["#4F46E5", "#22C55E"],
        borderRadius: 6,
        borderWidth: 0,
      },
    ],
  };

  return (
    <div
      className='pie-chart-wrapper'
      style={{
        height: "380px",
        width: "100%",
        maxWidth: "500px",
        margin: "0 auto",
        padding: "10px",
      }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart2;
